import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

export const StatColumn: React.FC<{ label: string; value: number; adjustedValue?: number; signed?: boolean; onClick?: (e: React.MouseEvent<HTMLElement>) => void }> = ({
  label,
  value,
  adjustedValue,
  signed = false,
  onClick
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: 0.5,
      py: 1,
    }}
  >
    <Typography variant="caption" color="textSecondary">
      {label}
    </Typography>
    <Chip
      label={`${signed && (adjustedValue ?? value) >= 0 ? '+' : ''}${adjustedValue ?? value}${adjustedValue !== value && adjustedValue !== undefined ? '/' + value: ''}`}
      onClick={onClick}
      sx={{
        fontWeight: 700,
        fontSize: '1rem,',
        cursor: onClick ? 'pointer' : 'default',
        backgroundColor: (theme) => adjustedValue !== undefined && adjustedValue !== value
          ? (theme.palette.mode === 'dark' ? 'rgba(0, 255, 65, 0.16)' : 'white')
          : 'transparent'
      }}
    />
  </Box>
);
